import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import EmployeeEnrollmentFields from './EmployeeEnrollmentFields'

export const EmployeeEnrollmentEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <EmployeeEnrollmentFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default EmployeeEnrollmentEdit
